var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M95 40c11.046 0 20 8.954 20 20v160c0 11.046-8.954 20-20 20H85c-11.046 0-20-8.954-20-20V60c0-11.046 8.954-20 20-20zm100 0c11.046 0 20 8.954 20 20v160c0 11.046-8.954 20-20 20h-10c-11.046 0-20-8.954-20-20V60c0-11.046 8.954-20 20-20z"
})));
export default SvgPause;